<div class="aod-dialog-container">
  <div class="dialog-title">Add AOD type expense</div>
  <form
    [formGroup]="form"
    (ngSubmit)="submit()"
    autocomplete="off"
    class="aod-form"
  >
    <div class="field-grid">
      <mat-form-field appearance="fill">
        <mat-label>Expense Name</mat-label>
        <input matInput formControlName="expenseName" />
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Status</mat-label>
        <input matInput formControlName="status" />
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Start Date</mat-label>
        <input
          matInput
          [matDatepicker]="startPicker"
          formControlName="startDate"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="startPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Last Deducted Date</mat-label>
        <input
          matInput
          [matDatepicker]="lastDatePicker"
          formControlName="lastDeductedDate"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="lastDatePicker"
          [disabled]="true"
        ></mat-datepicker-toggle>
        <mat-datepicker #lastDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Interest rate(%)</mat-label>
        <input matInput formControlName="interestRate" type="number" />
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Total Amount</mat-label>
        <input matInput formControlName="amount" type="number" />
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Payment Frequency</mat-label>
        <mat-select formControlName="paymentFrequency">
          @for (option of paymentFrequencies; track $index) {
          <mat-option [value]="option.value">{{option.label}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Deduction Amount (% of earning)</mat-label>
        <input matInput formControlName="deductionAmount" type="number" />
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Balance Due</mat-label>
        <input matInput formControlName="balanceDue" type="number" />
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Number of deductions</mat-label>
        <input matInput formControlName="numberOfDeductions" type="number" />
      </mat-form-field>
    </div>

    <div class="upload-section">
      @if(!selectedFile){
      <div class="upload-label">Upload AOD document</div>
      <div
        class="upload-dropzone"
        (drop)="onFileDrop($event)"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        [class.active]="dragActive"
      >
        <mat-icon style="height: 48px; width: 48px">cloud_upload</mat-icon>
        <div>
          Drop your document here to upload,
          <span class="browse-link" (click)="fileInput.click()"
            >or click to browse</span
          >
        </div>
        <input
          #fileInput
          type="file"
          class="file-input"
          (change)="onFileSelected($event)"
        />
      </div>
      } @if(selectedFile){
      <div class="uploaded-file">
        <mat-icon style="width: 54px">description</mat-icon>
        {{ selectedFile.name }} @if(!viewOnly){
        <button
          mat-icon-button
          color="warn"
          (click)="removeFile()"
          type="button"
        >
          <mat-icon>delete</mat-icon>
        </button>
        }
      </div>
      }
    </div>

    @if (error) {
    <app-alert (close)="error=null" class="mt-3" type="error">
      {{ error }}
    </app-alert>
    }

    <div class="dialog-actions">
      @if(viewOnly){
      <button mat-stroked-button color="basic" (click)="close()" type="button">
        Close
      </button>
      } @if(!viewOnly){
      <button
        mat-flat-button
        color="primary"
        type="submit"
        [disabled]="form.invalid"
      >
        Save
      </button>
      <button mat-stroked-button color="basic" (click)="close()" type="button">
        Cancel
      </button>
      }
    </div>
  </form>
</div>
